export class InnerRowValue {
  value: string;
  idColumn: string;
}
